import React from 'react';
import { Node } from '@uncinc/react-drupal-core';
import {
  Image,
} from '@uncinc/uncinc-react-kitchen-sink';
import i18next from '../../../config/i18next';


import {
  Container,
  Button,

  Loader,
  PatternBlock,
} from '../../../components';

import './style.scss';

const ViewMemberStories = ({ pager, onLoadMore, loading, ...props }) => {
  const { entities, image, title, ctaTitle, ctaUrl } = props;
  const itemsPerPage = pager.get('items_per_page');
  const totalItems = pager.get('total_items');
  const currentPage = pager.get('current_page');
  const currentItemCount = (currentPage + 1) * itemsPerPage;
  const pagerVisible = currentItemCount < totalItems;
  const imgSrcMobile = image.getIn([0, 'styles', 'medium']);
  const imgSrc = image.getIn([0, 'styles', 'large']);

  // Limit the amount of items to be displayed. We need to calculate limit the
  // amount of items to display to one less, since we want to prepend a block
  // with the selected image imgSrc. The last item is always replaced with
  // displaying the CTA.
  const amountOfItemsPerPage = 6;
  const amountOfItemsTotal = (Math.floor(entities.size / amountOfItemsPerPage) * amountOfItemsPerPage) - 1;

  return (
    <div className="View ViewMemberStories">
      <Container>
        <div className="row">
          {entities.count() === 0 && (
            <div className="View__empty col-12 mb-6">{ i18next.t('views.no_results') }</div>
          )}

          <div className="ViewMemberStories__image col-12 col-xs-12 col-sm-12 col-md-6 col-lg-4 pt-5 pb-5">
            <Image
              src={{
                0: imgSrcMobile,
                768: imgSrc,
              }}
              includeWebP
            />
          </div>

          {
            Array.from({ length: amountOfItemsTotal }).map((empty, key) => {
              const entity = entities.get(key);
              const id = entity.getIn(['nid', '0', 'value']);
              const uuid = entity.getIn(['uuid', 0, 'value']);
              const langcode = entity.getIn(['langcode', 0, 'value']);
              const className = 'ViewMemberStories__item col-12 col-xs-12 col-sm-12 col-md-6 col-lg-4 pt-5 pb-5';

              // Replace the last image with the CTA.
              if (key === (amountOfItemsTotal - 1)) {
                return (
                  <div className="col-12 col-xs-12 col-sm-12 col-md-6 col-lg-4 pt-5 pb-5">
                    <PatternBlock className="ViewMemberStories__CTA">
                      <h3>{title}</h3>
                      <Button
                        secondary
                        withIcon
                        buttonIcon
                        href={ctaUrl}
                      >
                        {ctaTitle}
                      </Button>
                    </PatternBlock>
                  </div>
                );
              }
              return (
                <div key={`${uuid}:${langcode}`} className={className} data-key={key}>
                  <Node
                    id={id}
                    key={`${uuid}:${langcode}`}
                    isActivePath
                    viewMode="teaser"
                    entity={entity}
                  />
                </div>
              );
            })
          }

        </div>
      </Container>
      <Container>
        {pagerVisible && (
          <div className="ViewAwards__button">
            <Button
              className="ViewAwards__Button"
              secondary
              withIcon
              buttonIconVertical
              href="#"
              onClick={(e) => {
                e.preventDefault();
                onLoadMore();
              }}>{ i18next.t('view_load_more') }
            </Button>
          </div>
        )}
      </Container>
      <Loader loading={loading} />
    </div>
  );
};

export default ViewMemberStories;
